var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-control-static inline-editable",on:{"mouseup":function($event){$event.stopPropagation();return _vm.doClick($event)}}},[(_vm.value)?_vm._t("edit"):(!_vm.empty)?_vm._t("view"):void 0],2)}
var staticRenderFns = []

export { render, staticRenderFns }